import VueApexCharts from 'vue3-apexcharts';

export const registerApexcharts = (app) => {
  app.use(VueApexCharts);
};